import { render, staticRenderFns } from "./ItemsRentForInvoice.vue?vue&type=template&id=2cf98e9b&scoped=true&"
import script from "./ItemsRentForInvoice.vue?vue&type=script&lang=js&"
export * from "./ItemsRentForInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentForInvoice.vue?vue&type=style&index=0&id=2cf98e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf98e9b",
  null
  
)

export default component.exports